import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TModalAuthState } from 'shared/common/types/modalAuth';

const initialState: TModalAuthState = {
  isOpen: false,
};

/* istanbul ignore next */
const modalStatusSlice = createSlice({
  initialState,
  name: 'cianCard',
  reducers: {
    setModalVisible: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
  },
});

export const {
  reducer: modalStatusReducer,
  actions: { setModalVisible },
} = modalStatusSlice;
